var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_setup.phases,"label":"Phase filter"},model:{value:(_setup.currentPhase),callback:function ($$v) {_setup.currentPhase=$$v},expression:"currentPhase"}})
}
var staticRenderFns = []

export { render, staticRenderFns }